function loadInstagramEmbed() {
  var existing = document.getElementById("instagram-wjs");
  if (existing) existing.remove();

  var js = document.createElement("script");
  js.id = "instagram-wjs";
  js.src = "https://www.instagram.com/embed.js";
  js.onload = function() {
    console.log("[Instagram] embed.js loaded");
    triggerInstagramEmbeds();
  };
  document.body.appendChild(js);
}

function triggerInstagramEmbeds() {
  var retryCount = 0;
  var maxRetries = 12;
  var interval = setInterval(function() {
    if (window.instgrm && window.instgrm.Embeds) {
      try {
        console.log("[Instagram] processing embeds...");
        window.instgrm.Embeds.process();
      } catch(e) {
        console.warn("[Instagram] process failed:", e);
      }
      retryCount++;
      if (retryCount >= 2) {
        clearInterval(interval);
      }
    } else {
      retryCount++;
      console.log("[Instagram] waiting...", retryCount);
      if (retryCount >= maxRetries) clearInterval(interval);
    }
  }, 500);
}

document.addEventListener("DOMContentLoaded", loadInstagramEmbed);
document.addEventListener("shopify:section:load", function(){
  setTimeout(loadInstagramEmbed, 600);
});
document.addEventListener("shopify:page:load", loadInstagramEmbed);
document.addEventListener("turbo:load", loadInstagramEmbed);